import React, { memo, useState } from 'react';
import { useLang } from '../../util/lang';
import Modal from '../../components/Modal/modal';
import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import { safeGet } from '../../axios-default';
import SmileDesignPrescriptionNotesPreviewMap from './SmileDesignPrescriptionNotesPreviewMap';

const getSmileDesignPrescriptionNotesData = async (caseId) => {
    const results = await safeGet(`/case/smileDesignPrescriptionNotes/${caseId}`);
    return results;
};

const useStyles = makeStyles({
    customColor: {
        color: '#593686', // Set your desired color here
    },
});

const SmileDesignPrescriptionNotesModalButton = ({ classes, caseId }) => {
    const loader = useStyles();
    const get = useLang();
    const [isOpen, setIsOpen] = useState(false);
    const [data, setData] = useState();

    const handleOpen = async () => {
        setIsOpen(true);
        if (caseId !== undefined) {
            const data = await getSmileDesignPrescriptionNotesData(caseId);
            setData(data.result);
        }
    };

    return (
        <>
            <Button className={classes.linkBtn} onClick={handleOpen}>
                {get('@PatientInfo.case_info.documentsList.viewQuestionnaire')}
            </Button>

            <Modal
                className="prescriptionNotes"
                modal="prescriptionNotes"
                title={'Smile Design ' + get('@PatientInfo.modals.prescriptionNotesModalTitle')}
                handleClose={() => setIsOpen(false)}
                open={isOpen}
                submitButton={false}
                modalError={false}
            >
                {data ? (
                    <SmileDesignPrescriptionNotesPreviewMap
                        defaultValues={data}
                        previewAfterSubmitbyisMarieGroup={data['isMarieGroup']}
                    />
                ) : (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress className={loader.customColor} size={60} />
                    </div>
                )}
            </Modal>
        </>
    );
};

export default memo(SmileDesignPrescriptionNotesModalButton);
